<app-header-web (toggleChange)="toggleMenu()"></app-header-web>
<app-main-page [isExpanded]="isExpanded" [isloggedIn]="isLoggedIn">
  <div selector>
    <div class="page-container" *ngIf="isLoggedIn">
      <router-outlet></router-outlet>
    </div>
    <div class="notLogged" *ngIf="!isLoggedIn">
      <router-outlet></router-outlet>
    </div>
  </div>
</app-main-page>

<div class="card flex justify-content-center">
  <p-toast [position]="'top-center'"/>
</div>
